// extracted by mini-css-extract-plugin
module.exports = {"lastUpdate":"index-module--lastUpdate--3PlA2","emphasizedLink":"index-module--emphasized-link--3kJvL","schedule":"index-module--schedule--3pzhc"};